export const update = {
  form: {
    name: 'Name',
    typeName: 'Type name',
    washingInfo: 'Washing info',
    tankInfo: 'Tank info',
    tankNo: 'Tank no',
    update: 'Update',
    cancel: 'Cancel',
    select: 'Select',
    requireCode: 'Please input machine name',
    requireTypeName: 'Please input machine type name',
  },
  pageHeader: {
    title: 'Update Machine',
    back: 'Back',
  },
}
